import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  signal,
} from '@angular/core';

import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';

import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';

import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { RouterModule } from '@angular/router';

import { AppService } from '@app/app.service';
import { AuthService } from '@app/auth/auth.service';

interface LegalAcceptanceDialogData {
  requires_terms_of_service_acceptance: boolean;
  requires_privacy_policy_acceptance: boolean;

  current_terms_of_service_version: string | null;
  accepted_terms_of_service_version: string | null;

  current_privacy_policy_version: string | null;
  accepted_privacy_policy_version: string | null;
}

@Component({
  selector: 'app-legal-acceptance-dialog',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatDialogModule,
    MatCheckboxModule,
    MatButtonModule,
    MatProgressSpinner,
    RouterModule,
  ],
  templateUrl: './legal-acceptance-dialog.component.html',
  styleUrls: ['./legal-acceptance-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LegalAcceptanceDialogComponent {

  loading = signal(false);

  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private appService: AppService,
    private authService: AuthService,

    private dialogRef: MatDialogRef<LegalAcceptanceDialogComponent>,

    @Inject(MAT_DIALOG_DATA)
    public data: LegalAcceptanceDialogData,
  ) {
    this.form = this.fb.group({
      accept_terms_of_service: [
        false,
        data.requires_terms_of_service_acceptance
          ? Validators.requiredTrue
          : [],
      ],

      accept_privacy_policy: [
        false,
        data.requires_privacy_policy_acceptance
          ? Validators.requiredTrue
          : [],
      ],
    });
  }

  acceptLegal(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.loading.set(true);

    this.appService.post('legal/accept', this.form.value).subscribe({
      next: (response) => {
        this.authService.setUserToStorage(response.data.user);
        this.authService.setPendingLegalAcceptance(false);

        this.dialogRef.close(true);
      },
      error: (error) => {
        this.appService.handleError(error);
        this.loading.set(false);
      },
    });
  }

  logout(): void {
    this.dialogRef.close(false);
    this.authService.logout();
  }

}